// extracted by mini-css-extract-plugin
export default {"productGrid":"j0-z","centerLink":"k0-z","productSection":"l0-z","item":"m0-z","ctaButton":"n0-z"};